import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { MaintenanceSlaSavedTimer } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';

export function useMaintenanceSlaReadTimerColumns() {
  const { t } = useTranslation('sla');
  const dash = t('oems.maintenance.dash');

  return useMemo(
    () => [
      {
        title: t('oems.maintenance.kind'),
        key: 'kind',
        render: (_: unknown, timer: MaintenanceSlaSavedTimer) => (
          <span style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ color: '#191c1f', fontWeight: 500 }}>
              {t(`oems.maintenance.timerKind.${timer.kind}`)}
            </span>
            <span
              style={{
                color: '#94a3b8',
                fontSize: 11,
                lineHeight: 1.3,
                marginTop: 2,
              }}
            >
              {t(`oems.maintenance.timerKindExplanation.${timer.kind}`)}
            </span>
          </span>
        ),
      },
      {
        title: t('oems.maintenance.clockStartLabel'),
        key: 'clockStart',
        render: (_: unknown, timer: MaintenanceSlaSavedTimer) =>
          timer.clockStart
            ? t(`oems.maintenance.clockStart.${timer.clockStart}`)
            : dash,
      },
      {
        title: t('oems.maintenance.calendarModeLabel'),
        key: 'calendarMode',
        render: (_: unknown, timer: MaintenanceSlaSavedTimer) =>
          timer.calendarMode
            ? t(`oems.maintenance.calendarMode.${timer.calendarMode}`)
            : dash,
      },
    ],
    [t, dash],
  );
}
